import React from "react";
import { FaWhatsapp, FaPhoneAlt } from "react-icons/fa";

function FloatingContactButtons() {
  const phoneNumber = "916303516127";
  const message = "Hello! I’d like to know more about your investment plans.";
  return (
    <div style={styles.container}>
      {/* WhatsApp Button */}
      <a
        href={`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`}
        target="_blank"
        rel="noopener noreferrer"
        style={{ ...styles.button, backgroundColor: "#25D366" }}
        title="Chat on WhatsApp"
      >
        <FaWhatsapp style={styles.icon} />
      </a>

      {/* Call Button */}
      <a
        href={`tel:+${phoneNumber}`}
        style={{ ...styles.button, backgroundColor: "#007bff" }}
        title="Call Now"
      >
        <FaPhoneAlt style={styles.icon} />
      </a>
    </div>
  );
}

const styles = {
  container: {
    position: "fixed",
    bottom: "20px",
    right: "20px",
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    zIndex: 9999,
     marginright:"10px",
  },
  button: {
    width: "55px",
    height: "55px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "white",
    fontSize: "26px",
    textDecoration: "none",
    boxShadow: "0px 4px 8px rgba(0,0,0,0.2)",
    transition: "transform 0.2s ease, box-shadow 0.2s ease",
  },
  icon: {
    pointerEvents: "none",
  },
};

// Add hover effects using inline pseudo-class with global CSS
const styleTag = document.createElement("style");
styleTag.innerHTML = `
a:hover {
  transform: scale(1.1);
  box-shadow: 0px 6px 12px rgba(0,0,0,0.3);
}
@media (max-width: 600px) {
  div[style*="fixed"] {
    bottom: 15px !important;
    right: 15px !important;
  }
}
`;
document.head.appendChild(styleTag);

export default FloatingContactButtons;
